import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom'; // Importer useNavigate
import authAPI from '../Services/authAPI';
import AuthContext from '../Contexts/AuthContext';
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Avatar,
  Checkbox,
  FormControlLabel,
  Link,
  Divider,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import FacebookIcon from '@mui/icons-material/Facebook';
import GitHubIcon from '@mui/icons-material/GitHub';
import GoogleIcon from '@mui/icons-material/Google';
import Grid from '@mui/material/Grid2';

function LoginPage() {
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { setIsAuthenticated, setRole, setFirstname, setLastname } = useContext(AuthContext);
  const navigate = useNavigate(); // Déclarer navigate

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCredentials({ ...credentials, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      await authAPI.authenticate(credentials);

      const role = authAPI.getRole();
      setRole(role);

      const identity = authAPI.getIdentity();
      setFirstname(identity.firstname);
      setLastname(identity.lastname);

      setIsAuthenticated(true);
      setLoading(false);
      
      navigate("/dashboard"); // Rediriger vers /dashboard une fois connecté

    } catch (error) {
      setError("Les identifiants sont incorrects ou un problème est survenu.");
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: 8,
          backgroundColor: 'white',
          padding: 4,
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Bienvenue sur MedClick Admin! 👋
        </Typography>
        <Typography variant="body2" color="textSecondary" align="center" sx={{ mt: 1 }}>
          Connectez-vous à votre compte pour démarrer votre aventure
        </Typography>

        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Nom d'utilisateur"
            name="username"
            autoComplete="username"
            autoFocus
            value={credentials.username}
            onChange={handleChange}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Mot de passe"
            type="password"
            name="password"
            autoComplete="current-password"
            value={credentials.password}
            onChange={handleChange}
          />
          {error && (
            <Typography color="error" variant="body2" align="center" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}
          <Grid container alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
            <Grid >
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Se souvenir de moi"
              />
            </Grid>
            <Grid >
              <Link href="#" variant="body2">
                Mot de passe oublié?
              </Link>
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={loading}
            sx={{ mt: 3, mb: 2 }}
          >
            {loading ? "Connexion en cours..." : "Connexion"}
          </Button>
          <Divider sx={{ my: 2 }}>ou</Divider>
          <Grid container justifyContent="center" spacing={2}>
            <Grid >
              <Link href="#" variant="body2">
                <FacebookIcon fontSize="large" />
              </Link>
            </Grid>
            <Grid >
              <Link href="#" variant="body2">
                <GitHubIcon fontSize="large" />
              </Link>
            </Grid>
            <Grid>
              <Link href="#" variant="body2">
                <GoogleIcon fontSize="large" />
              </Link>
            </Grid>
          </Grid>
          <Grid container justifyContent="center" sx={{ mt: 2 }}>
            <Typography variant="body2">
              Nouveau sur notre plateforme? <Link href="#">Créer un compte</Link>
            </Typography>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
}

export default LoginPage;
